import { ROUTE_PATH } from "common/constants/sm-constants";
import { GridMetaModel } from "common/models/utility-models/meta-model";

export class studentFeedbackGridMetaModel extends GridMetaModel<Headers> {
    constructor() {
        super(
            'Student Feedback',
            ROUTE_PATH.studentFeedbackGrid,
            '',
            false,
            false,
            8,
            false,
            false,
  
        );
    }

    prepareHeaderList(): Headers[] {
        const headers: Headers[] = [];
       
     
        return headers;
    }
}